import React from "react";
import { DataCardShell } from "../../../../../components/responsive";
import Helpers from "../../../../../components/Helpers";
import {
  actionBadgeClass,
  ChangedDataView,
  displayActor,
  displayRole,
  eventLabel,
  ModuleLinkCell,
} from "../../../../../utils/activityLogFormat";

export function LogReportCard({ row }: { row: any }) {
  return (
    <DataCardShell
      title={[displayActor(row), displayRole(row) !== "—" ? displayRole(row) : null]
        .filter(Boolean)
        .join(" · ")}
      subtitle={
        row.createdTime
          ? Helpers.convertUtcToTimezone(row.createdTime, "MM-DD-YYYY hh:mm a")
          : "—"
      }
      chips={
        <span className={`badge ${actionBadgeClass(row.action)}`}>
          {row.action || "—"}
        </span>
      }
      fields={[
        { label: "Module", value: <ModuleLinkCell row={row} /> },
        { label: "Event", value: eventLabel(row.eventType) || "—" },
        {
          label: "Changed data",
          value: (
            <ChangedDataView raw={row.changedData} parsed={row.changedDataParsed} />
          ),
        },
      ]}
    />
  );
}
